import { useState } from "react";
import { industrySolutions } from "../data/servicesData";

function IndustryTabbedView() {
  const [activeId, setActiveId] = useState(industrySolutions[0].id);
  const active =
    industrySolutions.find((industry) => industry.id === activeId) ??
    industrySolutions[0];

  return (
    <div className="industry-tabs">
      <div className="industry-tabs__bar" role="tablist" aria-label="Industries">
        {industrySolutions.map((industry) => (
          <button
            type="button"
            role="tab"
            key={industry.id}
            aria-selected={activeId === industry.id}
            className={`industry-tab${
              activeId === industry.id ? " industry-tab--active" : ""
            }`}
            onClick={() => setActiveId(industry.id)}
          >
            <span className="industry-tab__icon" aria-hidden="true">
              <i className={`bi ${industry.icon}`} />
            </span>
            {industry.shortName}
          </button>
        ))}
      </div>
      <div className="industry-panel" role="tabpanel">
        <div className="industry-panel__icon" aria-hidden="true">
          <i className={`bi ${active.icon}`} />
        </div>
        <div className="industry-panel__body">
          <h3 className="industry-panel__title">{active.name}</h3>
          <p className="industry-panel__desc">{active.description}</p>
          <ul className="industry-panel__solutions">
            {active.solutions.map((solution) => (
              <li key={solution}>
                <i className="bi bi-check-circle-fill" />
                {solution}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default IndustryTabbedView;
